<template>
  <div id="preview-component">
    <default-preview v-if="getGameConsole == 'default'"></default-preview>
    <market-view v-if="getGameConsole == 'marketview'"></market-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DefaultPreview from '@/components/center_widgets/Previews/DefaultPreview'
import MarketView from '@/components/center_widgets/Previews/MarketView'

export default {
  name: 'Preview',
  components: {
    DefaultPreview,
    MarketView,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getGameConsole: 'settings/getGameConsole',
    }),
  },
}
</script>

<style></style>
